export default [
  {
    path: '',
    name: 'settings',
    component: () => import('@/views/app/settings/page-settings.vue'),
    meta: { title: 'Pengaturan Sistem' },
  },
]
